import React from 'react';

import { useApiClient } from '@eluve/api-client-provider';
import { Stack, Text } from '@eluve/components';
import {
  useAppointmentId,
  useAppointmentPatient,
  useAppointmentStatus,
  useListenForAppointmentLlmJobStatus,
  useListenForAppointmentPatient,
  useTenantId,
} from '@eluve/frontend-appointment-hooks';
import { DbEnums } from '@eluve/graphql-types';
import { patientOverviewSchema } from '@eluve/llm-outputs';

export const Situation: React.FC = () => {
  const patient = useAppointmentPatient();
  const appointmentId = useAppointmentId();
  const tenantId = useTenantId();
  const apiClient = useApiClient();
  const apptStatus = useAppointmentStatus();

  const { status } = useListenForAppointmentLlmJobStatus({
    outputType: DbEnums.LlmOutputType.PATIENT_OVERVIEW,
    shouldSubscribe: apptStatus === DbEnums.AppointmentStatus.NOT_STARTED,
  });

  useListenForAppointmentPatient();

  const patientOverviews = patient?.patient_overviews ?? [];
  const currentPatientOverview = patientOverviews.find(
    (overview) => overview.isCurrent,
  );
  const parsedOverview = patientOverviewSchema.safeParse(
    currentPatientOverview?.content ?? '',
  );

  if (!parsedOverview.success) {
    return null;
  }

  // Extract text from details array
  const detailsText = parsedOverview.data.details
    .map((detail) => detail.text)
    .join('\n');

  return (
    <Stack
      align="stretch"
      className="rounded-xl border border-border-primary bg-bg-secondary p-4"
      gap={2}
    >
      <Text weight="semibold">Situation</Text>
      <Text
        className={`${'text-sm font-medium text-text-primary'} ${
          status === DbEnums.WorkerStatus.IN_PROGRESS
            ? 'animate-pulse opacity-30'
            : ''
        }`}
      >
        {detailsText}
      </Text>
    </Stack>
  );
};
